import { createSlice } from "@reduxjs/toolkit";
import { fynitoApi } from "../../../Components/Services/axios";
// Direct toast import removed - using toastify helper instead
import toastify from "../../../helper/toastify";

const token = localStorage.getItem("token");
const userLocal = localStorage.getItem("user")
const commonsetting = localStorage.getItem("commonsetting")
const commonwebdata = localStorage.getItem("commonwebdata")
const address = localStorage.getItem("address")
const paymentGatewayData = localStorage.getItem("paymentGatewayData")
const initialState = {
    user: userLocal ? JSON.parse(userLocal) : null,
    token: token ? token : null,
    commonwebData: commonwebdata ? JSON.parse(commonwebdata) : null,
    commonData: commonsetting ? JSON.parse(commonsetting) : null,
    addressData: address ? JSON.parse(address) : null,
    paymentGatewayData: paymentGatewayData ? JSON.parse(paymentGatewayData) : null,
    isLogin: token ? true : false,
    loading: false,
    error: null,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        loginSuccess: (state, action) => {
            state.loading = false;
            state.token = action.payload;
            state.isLogin = true;
            localStorage.setItem("token", action.payload);
        },
        resendOtpSuccess: (state) => {
            state.loading = false;
        },
        setUserProfile: (state, action) => {
            state.user = action.payload;
            state.loading = false;
            localStorage.setItem("user", JSON.stringify(action.payload));
        },
        setUserCommomSetting: (state, action) => {
            state.commonData = action.payload;
            state.loading = false;
            localStorage.setItem("commonsetting", JSON.stringify(action.payload));
        },
        setCommomWebSetting: (state, action) => {
            state.commonwebData = action.payload;
            state.loading = false;
            localStorage.setItem("commonwebdata", JSON.stringify(action.payload));
        },
        setUserAddress: (state, action) => {
            state.addressData = action.payload;
            state.loading = false;
            localStorage.setItem("address", JSON.stringify(action.payload));
        },
        setPaymentGatewayData: (state, action) => {
            state.paymentGatewayData = action.payload;
            state.loading = false;
            localStorage.setItem("paymentGatewayData", JSON.stringify(action.payload));
        },
        logoutUser: (state) => {
            state.token = null;
            state.isLogin = false;
            state.loading = false;
            state.error = null;
            state.user = null;
            state.commonData = null;
            state.addressData = null;
            state.paymentGatewayData = null;
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            localStorage.removeItem("commonsetting");
            localStorage.removeItem("address");
            localStorage.removeItem("selectedAddress");
            localStorage.removeItem("paymentGatewayData");
        },
    }
});

export const { loginSuccess, logoutUser, setLoading, resendOtpSuccess, setUserProfile, setUserCommomSetting, setUserAddress, setCommomWebSetting, setPaymentGatewayData } = authSlice.actions;

// Async API calls
export const login = (credentials) => async (dispatch) => {
    try {
        const response = await fynitoApi.post("/register-old-login", credentials);
        if (response.data.status_code === 200) {
            toastify.success("Otp Send Successfully")
            return { success: true };
        } else {
            toastify.error(response.data.message)
            return { success: false };
        }
    } catch (error) {
        console.log(error.response?.data?.message || "Login failed");
        return { success: false };
    }
};

export const verifyOtp = (otpData) => async (dispatch) => {
    try {
        const response = await fynitoApi.post("/otp-verify", otpData);
        if (response.data.status_code === 200) {
            const token = response.data.data.token
            localStorage.setItem("token", token)
            toastify.success(response.data.message)
            dispatch(loginSuccess(token));
            dispatch(getUserProfile());
            return { success: true };
        } else {
            toastify.error(response.data.message)
            return { success: false };
        }
        
    } catch (error) {
        console.log(error.response?.data?.message || "OTP verification failed");
        return { success: false };
    }
};

export const resendOtp = (payload) => async (dispatch) => {
    try {
        const response = await fynitoApi.post("/otp-resend", payload);
        if (response.data.status_code === 200) {
            toastify.success(response.data.message)
            dispatch(resendOtpSuccess());
            return { success: true };
        } else {
            toastify.error(response.data.message)
            return { success: false };
        }

    } catch (error) {
        console.log(error.response?.data?.message || "Resend OTP failed");
        return { success: false };
    }
};

export const getUserProfile = () => async (dispatch) => {
    try {
        const response = await fynitoApi.get("/profile-get");
        if (response.data.status_code === 200) {
            dispatch(setUserProfile(response.data.data));
            dispatch(setUserCommomSetting(response.data.comman_setting));
            dispatch(setUserAddress(response.data.address));
            // Store payment gateway data if available
            if (response.data.payment_getway) {
                dispatch(setPaymentGatewayData(response.data.payment_getway));
            }
            return { success: true };
        } else {
            toastify.error(response.data.message);
            return { success: false };
        }
    } catch (error) {
        // Check if this is a 401 error that's already been handled by the interceptor
        const is401Error = error.response?.status === 401 || 
                          error.status === 401 ||
                          error._isHandled401 ||
                          error.isHandled;
        
        // If it's a handled 401, silently return (interceptor already handled logout/redirect)
        if (is401Error) {
            dispatch(setLoading(false));
            return { success: false };
        }
        
        // For other errors, log and return failure
        dispatch(setLoading(false));
        console.log(error.response?.data?.message || "Failed to fetch profile");
        return { success: false };
    }
};

export const updateUserProfile = (profileData) => async (dispatch) => {
    try {
        const response = await fynitoApi.post("/profile-update", profileData);
        if (response.data.status_code === 200) {
            dispatch(getUserProfile());
            return { success: true };
        } else {
            toastify.error(response.data.message);
            return { success: false };
        }
    } catch (error) {
        console.log(error.response?.data?.message || "Failed to update profile");
        return { success: false };
    }
};

export const updateProfileImage = (payload) => async (dispatch) => {
    try {
        const imageData = new FormData();
        imageData.append('profile', payload);
        const response = await fynitoApi.post("/profile-image-update", imageData);
        if (response.data.status_code === 200) {
            dispatch(getUserProfile());
            toastify.success(response.data.message || "Profile image updated successfully");
            return { success: true };
        } else {
            toastify.error(response.data.message || "Failed to update profile image");
            return { success: false };
        }
    } catch (error) {
        console.log(error.response?.data?.message || "Failed to update profile image");
        return { success: false };
    }
};

export const getCommonSetting = () => async (dispatch) => {
    try {
        const response = await fynitoApi.get("/comman-setting");
        if (response.data.status_code === 200) {
            dispatch(setCommomWebSetting(response.data.data));
        } else {
            toastify.error(response.data.message || "Failed to fetch common setting");
        }
    } catch (error) {
        // Check if this is a 401 error that's already been handled by the interceptor
        const is401Error = error.response?.status === 401 || 
                          error.status === 401 ||
                          error._isHandled401 ||
                          error.isHandled;
        
        // If it's a handled 401, silently return (interceptor already handled logout/redirect)
        if (!is401Error) {
            console.log(error.response?.data?.message || "Failed to fetch common setting");
        }
        // Silently handle 401 errors as they're already handled by the interceptor
    }
};


export default authSlice.reducer;